import { ModelBase } from "../base"
import { QuestionnaireQuestionOptionContentModel } from "./option-content"

export class QuestionnaireQuestionOptionModel extends ModelBase {
    id = 0;
    languageId = 0;
    questionnaireQuestionId = 0;
    answerNumeric = 0;
    answerBool = false;
    answerText = "";
    optionContent = [
        new QuestionnaireQuestionOptionContentModel()
    ]

    constructor(params) {
        super();
        this.mapModel(params);
    }
}